import React from "react";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "extranet-component-library";
import tib from "../assets/img/TIB.svg";
const { REACT_APP_EXTRANET_APP_URL } = process.env;

const NotFound = () => {
  const { t } = useTranslation();

  const goBack = () => {
    window.location.replace(
      REACT_APP_EXTRANET_APP_URL !== undefined ? REACT_APP_EXTRANET_APP_URL : "https://novaxarxa.tib.org/extranet"
    );
  };

  return (
    <div className="error_404">
      <div className="header">
        <img src={tib} alt="tib" />
      </div>
      <div className="error">404</div>
      <div className="text">
        Ups!
        <br />
        {t("error_404")}
      </div>
      <div className="text">
        <PrimaryButton onClick={() => goBack()} text={t("go_back")} />
      </div>
    </div>
  );
};

export default NotFound;
